// Planned exam month (brief 035, P-2): stored as "YYYY-MM" on the profile, or absent.
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export const isExamMonth = v => typeof v === 'string' && /^\d{4}-(0[1-9]|1[0-2])$/.test(v);

// "Exam Mar 2027", or '' when not set.
export const examMonthLabel = v => (isExamMonth(v) ? `Exam ${MONTHS[Number(v.slice(5)) - 1]} ${v.slice(0, 4)}` : '');

// This year to two years ahead.
export const examYears = (now = new Date()) => [0, 1, 2].map(i => now.getFullYear() + i);

// Picking a month without a year: the next time that month comes round.
export const withMonth = (current, month, now = new Date()) => {
  if (!month) return '';
  const mm = String(month).padStart(2, '0');
  if (isExamMonth(current)) return `${current.slice(0, 4)}-${mm}`;
  const year = Number(mm) < now.getMonth() + 1 ? now.getFullYear() + 1 : now.getFullYear();
  return `${year}-${mm}`;
};
export const withYear = (current, year) => (isExamMonth(current) && year ? `${year}-${current.slice(5)}` : current);
